/* Valgt sykkel — feltet øverst på samlings- og produktsidene.
   Sykkelsøket og kjedesett-veiviseren lagrer sykkelen i localStorage
   (mcs_sykkel = {merke, modell, aar, url}). Her viser vi den, med lenke
   tilbake til delene for sykkelen. På produktsider spør vi katalogbasen
   (ymm_passer) om varen passer. */
(function () {
  const rot = document.getElementById('valgt-sykkel');
  if (!rot) return;

  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function hent() {
    try { return JSON.parse(localStorage.getItem('mcs_sykkel') || 'null'); } catch (e) { return null; }
  }

  function delesok(s) {
    const p = new URLSearchParams({ merke: s.merke, modell: s.modell, aar: s.aar });
    return '/pages/sykkelsok?' + p.toString();
  }

  // ---------- kundekontoen ----------
  // Innlogget kunde: sykkelen og garasjen lagres på kontoen (metafeltet custom.sykler,
  // via app proxy /apps/mcs/sykkel og Edge Function-en kunde-sykkel). Bare merke,
  // modell og år, aldri skiltnummer. På en ny enhet hentes de fra kontoen.
  const kunde = rot.dataset.kunde === '1';
  const lesListe = (k) => {
    try { const v = JSON.parse(localStorage.getItem(k) || 'null'); return Array.isArray(v) ? v : null; } catch (e) { return null; }
  };
  function lokaleSykler() {
    const ut = [], sett = new Set();
    [hent(), ...(lesListe('mcs_garasje') || [])].forEach((s) => {
      if (!s || !s.merke || !s.modell || !s.aar) return;
      const r = { merke: String(s.merke), modell: String(s.modell), aar: Number(s.aar) };
      const n = r.merke + '|' + r.modell + '|' + r.aar;
      if (!sett.has(n)) { sett.add(n); ut.push(r); }
    });
    return ut.slice(0, 5);
  }
  let kontoSykler = [];
  try { kontoSykler = JSON.parse(rot.dataset.sykler || 'null') || []; } catch (e) { kontoSykler = []; }
  if (!Array.isArray(kontoSykler)) kontoSykler = [];
  // Ny enhet (ingen garasje her ennå): hent fra kontoen.
  if (kunde && kontoSykler.length && lesListe('mcs_garasje') === null) {
    try {
      localStorage.setItem('mcs_garasje', JSON.stringify(kontoSykler.slice(0, 5)));
      if (!hent()) {
        const s = kontoSykler[0];
        localStorage.setItem('mcs_sykkel', JSON.stringify({ merke: s.merke, modell: s.modell, aar: Number(s.aar), url: delesok(s) }));
      }
    } catch (e) { /* privat modus */ }
  }
  let sistSendt = JSON.stringify(kontoSykler.map((s) => ({ merke: String(s.merke), modell: String(s.modell), aar: Number(s.aar) })));
  function synk() {
    if (!kunde) return;
    const tekst = JSON.stringify(lokaleSykler());
    if (tekst === sistSendt) return;
    sistSendt = tekst;
    fetch('/apps/mcs/sykkel?s=' + encodeURIComponent(tekst), {
      credentials: 'same-origin', keepalive: true, headers: { Accept: 'application/json' },
    }).catch(() => { /* prøver igjen neste side */ });
  }
  window.addEventListener('pagehide', synk);

  const posNorsk = (p) => String(p || '').toUpperCase()
    .replace(/FRONT/g, 'foran').replace(/REAR/g, 'bak')
    .replace(/LEFT/g, 'venstre').replace(/RIGHT/g, 'høyre')
    .replace(/_/g, ' ').toLowerCase().trim();

  function tegn() {
    const s = hent();
    if (!s || !s.merke || !s.modell || !s.aar) { rot.hidden = true; rot.innerHTML = ''; return; }
    const navn = `${s.merke} ${s.modell} ${s.aar}`;
    // Bare lenker innad i butikken.
    const tilbake = typeof s.url === 'string' && /^\/[^/\\]/.test(s.url) ? s.url : delesok(s);
    const tilKjedekit = tilbake.indexOf('/pages/kjedesett') === 0;

    rot.innerHTML = `<div class="vs__indre">
      <svg class="vs__ikon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="5.5" cy="16.5" r="3.5"/><circle cx="18.5" cy="16.5" r="3.5"/><path d="M5.5 16.5 9 10h5l4.5 6.5M9 10 8 7H6m8 3 2-3h2"/></svg>
      <span class="vs__tekst">Din sykkel: <strong>${esc(navn)}</strong></span>
      <span class="vs__pass" data-pass hidden></span>
      <span class="vs__lenker">
        <a class="vs__tilbake" href="${esc(tilbake)}">&larr; ${tilKjedekit ? 'Tilbake til kjedesett for sykkelen' : 'Tilbake til delene for sykkelen'}</a>
        <a class="vs__bytt" href="/pages/sykkelsok">Bytt sykkel</a>
      </span>
      <button type="button" class="vs__lukk" aria-label="Fjern valgt sykkel" title="Fjern valgt sykkel">&times;</button>
    </div>`;
    rot.hidden = false;

    rot.querySelector('.vs__lukk').addEventListener('click', () => {
      try { localStorage.removeItem('mcs_sykkel'); } catch (e) { /* privat modus */ }
      rot.hidden = true;
      synk();
    });

    if (rot.dataset.produkt) sjekkPassform(s, navn);
  }

  async function sjekkPassform(s, navn) {
    const api = (rot.dataset.api || '').replace(/\/$/, '');
    const nokkel = rot.dataset.nokkel;
    if (!api || !nokkel) return;
    let rader;
    try {
      const svar = await fetch(api + '/rest/v1/rpc/ymm_passer', {
        method: 'POST',
        headers: { apikey: nokkel, Authorization: 'Bearer ' + nokkel, 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ p_merke: s.merke, p_modell: s.modell, p_aar: Number(s.aar), p_produkt: Number(rot.dataset.produkt) }),
      });
      if (!svar.ok) return;
      rader = await svar.json();
    } catch (e) { return; }
    if (!Array.isArray(rader) || !rader.length) return;

    const rang = { passer: 3, universal: 2, passer_ikke: 1, ukjent: 0 };
    const best = rader.reduce((a, r) => (rang[r.status] > rang[a.status] ? r : a), rader[0]);
    const felt = rot.querySelector('[data-pass]');
    if (!felt) return;

    if (best.status === 'passer') {
      const pos = posNorsk(best.posisjon);
      felt.className = 'vs__pass vs__pass--ja';
      felt.innerHTML = `&#10003; Passer sykkelen din${pos ? ' (' + esc(pos) + ')' : ''}`;
    } else if (best.status === 'universal') {
      felt.className = 'vs__pass vs__pass--uni';
      felt.textContent = 'Universal del — sjekk mål og feste';
    } else if (best.status === 'passer_ikke') {
      felt.className = 'vs__pass vs__pass--nei';
      felt.innerHTML = `&#10007; Passer ikke til ${esc(navn)}`;
    } else {
      return; // dekk, kjeder uten treff osv. — ingen påstand
    }
    felt.hidden = false;
  }

  // Sykkelsøket og kjedesett-veiviseren skriver valget i url-en med
  // history.replaceState. Der fanger vi det opp og husker sykkelen; feltet
  // vises ikke på disse sidene.
  if (rot.dataset.velger) {
    const husk = () => {
      const p = new URLSearchParams(location.search);
      const merke = p.get('merke'), modell = p.get('modell'), aar = p.get('aar');
      try {
        if (merke && modell && aar) {
          localStorage.setItem('mcs_sykkel', JSON.stringify({ merke, modell, aar: Number(aar), url: location.pathname + location.search }));
        } else if (!merke && hent()) {
          localStorage.removeItem('mcs_sykkel'); // «Nullstill»
        }
      } catch (e) { /* privat modus */ }
    };
    const opprinnelig = history.replaceState;
    let startet = false;
    history.replaceState = function () {
      const r = opprinnelig.apply(this, arguments);
      // Første kall uten sykkel i url-en er sidelasting, ikke nullstilling.
      if (startet || new URLSearchParams(location.search).get('merke')) {
        startet = true; husk();
        setTimeout(synk, 1500); // garasjen skrives av sykkelsok.js like etter
      }
      return r;
    };
    return;
  }

  tegn();
  synk();
  window.addEventListener('storage', (e) => { if (e.key === 'mcs_sykkel') tegn(); });
})();
